module.exports = __webpack_public_path__ + "static/media/iot-application-07.a53af486.jpg";